import React from 'react'
import './section-featured-articles.scss'
import CardFeaturedArticle from '../../molecules/card-featured-article/card-featured-article'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import Button from '../../../shared/components/atoms/button/button'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo'
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'

const SectionFeaturedArticles = () => {
  const isMobile = useMediaQuery()

  const { allContentfulVConfidentHome } = useStaticQuery(
    graphql`
      query articles {
        allContentfulVConfidentHome {
          nodes {
            node_locale
            paisesDeRestriccion
            tituloArticulos {
              raw
            }
            articulos {
              tituloDelArticulo
              imagenPrevisualizacionDelArticulo {
                gatsbyImageData
                description
              }
              slug
            }
            redireccionBotonArticulos
            botonArticulos
          }
        }
      }
    `
  )

  const optiondRender = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, next) => (
        <h2 className="f-section-featured-articles__title">{next}</h2>
      ),
    },
  }

  const contentInfo = allContentfulVConfidentHome.nodes.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  const dataLayerButtonArticles = (text) => {
    const userInfoEncrypt = encryptUserInfo()
    pushDataLayerEvent({
      event: 'Interacciones_Articulos_VConfident',
      category: 'v-confident',
      action: 'click',
      label: text,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <section className="f-section-featured-articles">
      <div className="f-section-featured-articles__wrapper">
        {documentToReactComponents(
          JSON.parse(contentInfo.tituloArticulos.raw),
          optiondRender
        )}
        <div className="f-section-featured-articles__cards">
          {contentInfo.articulos.map((article, index) => {
            if (isMobile && index >= 2) {
              return null
            }

            return (
              <CardFeaturedArticle
                key={`featureArticle-${index + 1}`}
                redirection={`${siteUrl}/academia/articulos/${article.slug}`}
                image={article.imagenPrevisualizacionDelArticulo}
                title={article.tituloDelArticulo}
              />
            )
          })}
        </div>

        <div className="f-section-featured-articles__btn">
          <Button
            text={contentInfo.botonArticulos}
            action={() => {
              dataLayerButtonArticles(contentInfo.botonArticulos)
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'ga_event',
                category: 'V-Confident :: Home',
                action: 'Click :: Artículos',
                label: contentInfo.botonArticulos,
                value: '',
              })
              window.location.href =
                siteUrl + '/' + contentInfo.redireccionBotonArticulos
            }}
            color="purple"
          />
        </div>
      </div>
    </section>
  )
}

export default SectionFeaturedArticles
